import apiClient from '@shared/apiClient'

export const getApiClient = () => apiClient.partneringOne('accounts')
